module.exports = __webpack_public_path__ + "img/xinnengyuang.91c1e595.png";